import { StyledTd, StyledTr } from "../../../../../../../styled";
import dayjs from "dayjs";
import { useState } from "react";
import { DateInput, DatesProvider } from "@mantine/dates";
import { toMantineDateString } from "src/utils/mantineDates";
import { rem } from "@mantine/core";
import { Select } from "src/components/shared/MantineCombobox";
import { useGetApi, usePostApi } from "../../../../../../../hooks";
import { getYachtId, normalizeDate } from "../../../../../../../utils";
import { useParams } from "react-router-dom";
import { mapMedData } from "../../utils";
import { useDispatch, useSelector } from "../../../../../../../redux/hooks";
import { setTotalPeriodData } from "../../../../../../../redux/slices/medicalHistorySlice";
import ConfirmationButton from "../../../../../../shared/ConfirmationButton/ConfirmationButton";
import { IconTrash } from "@tabler/icons-react";

interface Props {
  date: string;
  type: string;
  leaveid: string;
}
const selectData = [
  {
    value: "ONLEAVE",
    label: "Leave",
  },
  {
    value: "ONBOARD",
    label: "Onboard",
  },
];

const MedicalLeaveHistoryRow = ({
  date: defaultDate,
  type: defaultType,
  leaveid,
}: Props) => {
  const dispatch = useDispatch();
  const { userid } = useParams();
  const { post } = usePostApi();

  const { uppercase } = useSelector(state => state.preferencesSlice);
  const [date, setDate] = useState(defaultDate);
  const [type, setType] = useState(defaultType);

  const { refetch } = useGetApi<{ data: Record<string, any> }>({
    request: "get-med-history",
    body: {
      params: {
        userid,
        yachtid: getYachtId(),
      },
    },
    fetchOnInit: false,
  });

  const handleUpdateData = async (
    newDate: string,
    newType: string,
    deleteRecord?: boolean,
  ) => {
    const utcDate = normalizeDate(new Date(newDate));
    if (!utcDate || !newType) return;
    await post({
      request: "update-onleave-onboard",
      body: {
        params: {
          userid,
          leaveid,
          type: newType,
          date: utcDate.toISOString(),
          ...(deleteRecord && { archive: true }),
        },
      },
      onSuccess: e => {
        console.log(e);
      },
    });
    const data = await refetch();
    if (!data?.data) return;
    const { daysOffLeave, daysOnBoard, list } = data.data.medLeaveHistory;
    dispatch(setTotalPeriodData({ daysOnBoard, daysOffLeave, list }));
  };

  const handleChangeDate = (newDate: string | null) => {
    const parsedDate = dayjs(normalizeDate(newDate)).format("YYYY-MM-DD");
    setDate(parsedDate);
    void handleUpdateData(parsedDate, type);
  };

  const handleChangeType = (newType: string) => {
    setType(newType);
    void handleUpdateData(date, newType);
  };

  const handleDeleteRecord = () => {
    void handleUpdateData(date, type, true);
  };

  return (
    <StyledTr>
      <StyledTd style={{ padding: "5px 10px" }}>
        <DateInput
          value={toMantineDateString(date)}
          onChange={handleChangeDate}
          valueFormat="DD MMM YYYY"
          style={{
            width: rem(120),
          }}
          styles={{
            input: { textTransform: uppercase ? "uppercase" : "none" },
          }}
        />
      </StyledTd>

      <StyledTd style={{ padding: "5px 10px" }}>
        <Select
          data={selectData}
          value={type}
          onChange={handleChangeType}
          style={{ width: rem(130) }}
          styles={{
            input: { textTransform: uppercase ? "uppercase" : "none" },
          }}
        />
      </StyledTd>
      <StyledTd>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <ConfirmationButton
            modalText="Are you your sure you want to archive this record?"
            actionIcon
            actionIconProps={
              {
                style: { color: "red" },
              } as any
            }
            onConfirm={handleDeleteRecord}>
            <IconTrash />
          </ConfirmationButton>
        </div>
      </StyledTd>
    </StyledTr>
  );
};
export default MedicalLeaveHistoryRow;
